import { c as _c } from "react/compiler-runtime";
import { QueryClientProvider as DefaultQueryClientProvider, QueryClient } from '@tanstack/react-query';
import type { FC } from 'react';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});
export const QueryClientProvider: FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = <DefaultQueryClientProvider client={queryClient} {...props}>{children}</DefaultQueryClientProvider>;
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};